export interface Grocery {
  id: number;
  catalog_item_id?: number | null;
  name: string;
  brand?: string | null;
  category: string;
  description?: string | null;
  barcode?: string | null;
  unit?: string | null;
  packaging_size?: string | null;
  image?: string | null;
  image_thumbnail?: string | null;
  image_icon?: string | null;
  notes?: string | null;
  created_at?: string;
  updated_at?: string;
  active?: boolean;
  deleted?: boolean;
}

export interface GroceryFormData {
  name: string;
  brand: string;
  category: string;
  description: string;
  barcode: string;
  unit: string;
  packaging_size: string;
  image: string;
  image_thumbnail: string;
  image_icon: string;
  notes: string;
}

export const emptyGroceryFormData: GroceryFormData = {
  name: '',
  brand: '',
  category: '',
  description: '',
  barcode: '',
  unit: '',
  packaging_size: '',
  image: '',
  image_thumbnail: '',
  image_icon: '',
  notes: '',
};

// Catalog item from Open Food Facts
export interface GroceryCatalogItem {
  id: number;
  barcode: string;
  off_url?: string | null;
  name: string;
  generic_name?: string | null;
  brand?: string | null;
  quantity?: string | null;
  serving_size?: string | null;
  categories?: string | null;
  categories_tags?: string[] | null;
  labels?: string | null;
  labels_tags?: string[] | null;
  ingredients_text?: string | null;
  allergens?: string | null;
  allergens_tags?: string[] | null;
  traces?: string | null;
  traces_tags?: string[] | null;
  additives_tags?: string[] | null;
  nutriscore_grade?: string | null;
  nutriscore_score?: number | null;
  nova_group?: number | null;
  ecoscore_grade?: string | null;
  nutrition_data?: NutritionData | null;
  origins?: string | null;
  manufacturing_places?: string | null;
  countries?: string | null;
  stores?: string | null;
  packaging?: string | null;
  image_front_url?: string | null;
  image_front_thumb_url?: string | null;
  image_front_icon_url?: string | null;
  image_ingredients_url?: string | null;
  image_ingredients_thumb_url?: string | null;
  image_nutrition_url?: string | null;
  image_nutrition_thumb_url?: string | null;
  images?: CatalogImage[];
  source: string;
  completeness?: number | null;
  created_at: string;
  updated_at: string;
}

export interface NutritionData {
  energy_kcal_100g?: number;
  energy_kj_100g?: number;
  fat_100g?: number;
  saturated_fat_100g?: number;
  carbohydrates_100g?: number;
  sugars_100g?: number;
  fiber_100g?: number;
  proteins_100g?: number;
  sodium_100g?: number;
  salt_100g?: number;
}

export interface CatalogImage {
  type: 'front' | 'ingredients' | 'nutrition';
  image_url: string | null;
  thumbnail_url: string | null;
  icon_url: string | null;
}

// Search result (lightweight)
export interface GrocerySearchResult {
  barcode: string;
  name: string;
  brand?: string | null;
  quantity?: string | null;
  categories?: string | null;
  thumbnail_url?: string | null;
  image_url?: string | null;
  in_catalog: boolean;
  catalog_id?: number | null;
}

// Barcode lookup response
export interface BarcodeLookupResponse {
  found: boolean;
  source: 'catalog' | 'open_food_facts' | null;
  catalog_id: number | null;
  data: GroceryCatalogItem | null;
}

// Search response
export interface GrocerySearchResponse {
  results: GrocerySearchResult[];
}